import Swiper, {Pagination, Navigation, Autoplay} from 'swiper';
Swiper.use([Pagination, Navigation, Autoplay]);

export namespace RoyalTVSlider {
	let stopAllVideos = () => {
		let iframes = document.querySelectorAll('.rtv-slide-card__iframe');
		iframes.forEach((iframe) => {
			let originalSrc = iframe.getAttribute('src');
			iframe.setAttribute('src', originalSrc);
		});
	};

	let setupSlider = () => {
		let rtvSliders = document.querySelectorAll('.js-rtv-slider');
		//For Each Hero Slider Loop through and setup swiper
		rtvSliders.forEach((slider, index) => {
			let promises = [];
			let links = slider.querySelectorAll('.js-rtv-play');

			slider.classList.add(`rtv-slider__swiper--${index}`);
			const swiper = new Swiper(`.rtv-slider__swiper--${index}`, {
				slidesPerView: 3,
				slideActiveClass: "slide-active",
				spaceBetween: 0,
				slideToClickedSlide: true,
				initialSlide: 0,// second item is the starting slide

				breakpoints: {
					0: {
						slidesPerView: 1,
						spaceBetween: 0,
						initialSlide: 0
					},
					768: {
						slidesPerView: 2,
						spaceBetween: 20,
						initialSlide: 0,
					},
					1024: {
						slidesPerView: 3,
						spaceBetween: 20,
						initialSlide: 0
					}
				},

				navigation: {
					nextEl: `.rtv-slider__swiper--${index} .swiper-button-next`,
					prevEl: `.rtv-slider__swiper--${index} .swiper-button-prev`,
				},

				on: {
					slideChange: function () {
						links.forEach((link) => {
							stopAllVideos();
						});
					}
				}
			});

			Promise.all(promises).then((values) => {
				slider.classList.add('state-visible');
			});

		});
	}

	export const init = () => {
		setupSlider();
	}
}

document.addEventListener('DOMContentLoaded', RoyalTVSlider.init);
